export default __webpack_public_path__ + "static/media/cardReader.e7ee287c.svg";